// extracted by mini-css-extract-plugin
export default {"dot-container":"dot-container-87ca","tail":"tail-726a","pulse":"pulse-303d"};